<template>
  <div class="mappa">
    <b-container id="container_mappa" fluid>
      <b-row v-bind:class="{'hide_class': !mappa}">
        <b-col cols="12" md="12">
          <b-form-input v-model="searchbox" v-on:keyup.enter="searchBoxKeyEnter()" class="search_box" ref="searchbox" type="search" style="visibility: hidden;" placeholder="Seleziona il tuo indirizzo" :state="state.search_address" autocomplete="off"></b-form-input>
          <div class="mappa_componente" ref="mappa"></div>
          <br>
          <br>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { globalConf } from '@/config.global'

var map
var markers
export default {
  name: 'mappa',
  props: {
    mappa: {
      type: Boolean,
      default: true
    },
    via: {
      type: String,
      default: null
    },
    civico: {
      type: String,
      default: null
    },
    comune: {
      type: String,
      default: null
    },
    cap: {
      type: String,
      default: null
    },
    provincia: {
      type: String,
      default: null
    },
    nazione: {
      type: String,
      default: null
    },
    stato: {
      type: Object,
      default: null
    },
    blockUpdateNextMapChange: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    stato: {
      handler: function(v, ov){
        for(const key in v){
          if(this.state[key] !== undefined)
            this.state[key] = v[key]
        }
      },
      deep: true
    },
    data: {
      handler: function(v, ov){
        if(this.mapLoaded){
          if(this.flag.edited){
            this.flag.edited = false
          }else{
            var _this = this
            clearTimeout(this.dataDelay)
            this.dataDelay = setTimeout(function() {
              if(_this.mappa)
                _this.findPlaceByData(true)
              else
                _this.updateValue()
            }, 250)
          }
        }
      },
      deep: true
    },
    mappa: {
      handler: function(v, ov){
        if(!this.blockUpdateNextMapChange)
          this.updateValue()
        else
          this.$emit('update:blockUpdateNextMapChange', false)
      }
    },
    via: {
      handler: function(v, ov){
        if(this.mappa)
          this.data.maps.via = v
        else
          this.data.manual.via = v
      }
    },
    civico: {
      handler: function(v, ov){
        if(this.mappa)
          this.data.maps.civico = v
        else
          this.data.manual.civico = v
      }
    },
    comune: {
      handler: function(v, ov){
        if(this.mappa)
          this.data.maps.comune = v
        else
          this.data.manual.comune = v
      }
    },
    cap: {
      handler: function(v, ov){
        if(this.mappa)
          this.data.maps.cap = v
        else
          this.data.manual.cap = v
      }
    },
    provincia: {
      handler: function(v, ov){
        if(this.mappa)
          this.data.maps.provincia = v
        else
          this.data.manual.provincia = v
      }
    },
    nazione: {
      handler: function(v, ov){
        if(this.mappa)
          this.data.maps.nazione = v
        else
          this.data.manual.nazione = v
      }
    },
    state: {
      handler: function(v, ov){
        this.watchStatus()
      },
      deep: true
    },
  },
  data() {
    return {
      data: {
        maps:{
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
        },
        manual: {
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
        }
      },
      state: {
        via: null,
        civico: null,
        nazione: null,
        provincia: null,
        comune: null,
        cap: null,
        search_address: null,
        _search_address: null
      },
      flag: {
        maps: false,
        edited: false,
        mapLoaded: false
      },
      config: {
        center: {lat: 42.504154, lng: 12.646361},
        zoom: 6
      },
      dataDelay: null,
      searchbox: ""
    }
  },
  created: function(){
    Vue.loadScript("https://maps.googleapis.com/maps/api/js?key="+globalConf.gmaps+"&libraries=places")
    .then(() => {
      this.loadMap()
    })
    .catch((e) => {
      console.log("Errore durante il caricamento di Google Maps!")
      //console.log(e)
    })
  },
  methods: {
    loadMap(){
      map = new google.maps.Map(this.$refs.mappa, {
        center: this.config.center,
        streetViewControl: false,
        zoom: this.config.zoom
      })

      var input = this.$refs.searchbox.$el
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

      var _this = this

      map.addListener('bounds_changed', function() {
        searchBox.setBounds(map.getBounds())
      })

      markers = []

      searchBox.addListener('places_changed', function() {
        var places = searchBox.getPlaces()
        _this.placeChanged(places)
        _this.updateValue()
      })

      this.mapLoaded = true
      this.findPlaceByData(true)
    },
    placeChanged(places, watch = false){
      this.state._search_address = null
      var checkMsg = this.checkPlaces(places)
      if(checkMsg.length > 0){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: checkMsg[1],
          type: checkMsg[0]
        })

        if(checkMsg[0] === "error")
          this.state._search_address = false
        
        if(checkMsg[0] === "info"){
          this.searchbox = ""
          this.clearDataMap()
        }

        places = []

        this.clearMap()
      }else{
        //togliere document e mettere o variabile vue o ref
        //document.getElementById('search_box').value = places[0].formatted_address
        this.searchbox = places[0].formatted_address

        this.convertPlaceToData(places[0], watch)
        //this.convertPlaceToData(places[0].formatted_address, watch)
        this.setMap(places)
      }
    },
    setMap(places){
      this.resetMarkers()

      var bounds = new google.maps.LatLngBounds()
      places.forEach(function(place) {
        if (!place.geometry) {
          console.log("Returned place contains no geometry")
          return
        }
        var icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        }

        markers.push(new google.maps.Marker({
          map: map,
          icon: icon,
          title: place.name,
          position: place.geometry.location
        }))

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      map.fitBounds(bounds)
    },
    convertPlaceToData(places, watch = false){
      this.data.maps.civico = "";
      this.data.maps.via = "";
      this.data.maps.comune = "";
      this.data.maps.provincia = "";
      this.data.maps.nazione = "";
      this.data.maps.cap = "";
      let address = places.address_components;
      for(let i = 0; i < address.length; i++){
        if (address[i].types[0] === "street_number"){
          this.data.maps.civico = address[i].long_name;
        }else if (address[i].types[0] === "route"){
          this.data.maps.via = address[i].long_name;
        }else if (address[i].types[0] === "locality"){
          this.data.maps.comune = address[i].long_name;
        }else if (address[i].types[0] === "administrative_area_level_2"){
          this.data.maps.provincia = address[i].short_name;
        }else if (address[i].types[0] === "country"){
          this.data.maps.nazione = address[i].long_name;
        }else if (address[i].types[0] === "postal_code"){
          this.data.maps.cap = address[i].long_name;
        }
      }
      if(!watch)
        this.flag.edited = true
    },
    _old_convertPlaceToData(places, watch = false){
      var campi = places.split(",")

      this.data.maps.via = campi[0]
      this.data.maps.civico = campi[1]
      this.data.maps.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo

      var sub_campi = campi[2].split(" ")

      this.data.maps.cap = sub_campi[1]
      this.data.maps.provincia = sub_campi[sub_campi.length - 1]
      this.data.maps.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")

      if(!watch)
        this.flag.edited = true
    },
    checkPlaces(places){
      return []
      if(!places || places.length == 0 || places.length > 1){
        return ['info', "Non è stato possibile trovare il punto esatto dell'indirizzo fornito!"]
      }

      var luogo = places[0].formatted_address
      
      var campi = luogo.split(",")

      if(campi.length != 4){
        return ["error", "L'indirizzo inserito non è completo di tutte le informazioni necessarie!"]
      }

      if(campi[1].trim().split(" ").length != 1){
        return ["error", "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"]
      }

      if(!(campi[3].trim() == "Italia" || campi[3].trim() == "Italy")){
        return ["error", "Attualmente la mappa supporta solo indirizzi italiani! Inserisci l'indirizzo manualmente."]
      }

      var sub_campi = campi[2].trim().split(" ")

      if(sub_campi.length < 3)
        return ["error", "L'indirizzo inserito non è valido!"]

      if(isNaN(Number.parseInt(sub_campi[0].trim())))
        return ["error", "L'indirizzo inserito non contiene un CAP valido! Riprovare."]

      if(sub_campi[sub_campi.length - 1].trim().length != 2)
        return ["error", "La sigla della provincia inserita non è valida!"]

      return []
    },
    findPlaceByData(watch = false){
      if(this.data.maps.via && this.data.maps.civico && this.data.maps.cap && this.data.maps.comune && this.data.maps.provincia && this.data.maps.nazione){
        var luogo = this.data.maps.via+", "+this.data.maps.civico+", "+this.data.maps.cap+
                      " "+this.data.maps.comune+" "+this.data.maps.provincia+", "+this.data.maps.nazione

        var _this = this
        
        var request = {
          query: luogo,
          fields: ['formatted_address', 'geometry', 'html_attributions', 'icon', 'id', 'name', 'place_id', 'plus_code', 'reference', 'types'],
        }

        var service = new google.maps.places.PlacesService(map)

        service.findPlaceFromQuery(request, function(results, status) {
          //_this.placeChanged(results, watch)
        })

      }else
        //togliere document e mettere o variabile vue o ref
        //document.getElementById('search_box').value = ""
        this.searchbox = ""
    },
    resetMarkers(){
      markers.forEach(function(marker) {
        marker.setMap(null)
      })
      markers = []
    },

    watchStatus(){
      for(const key in this.state){
        if(key !== "search_address" && this.state[key] !== null && !this.state[key]){
          this.state.search_address = false
          return
        }
      }

      this.state.search_address = null
    },
    toggleAddress(){
      this.$emit('update:mappa', !this.mappa)
    },
    updateValue(){
      this.$emit('update:via', (this.mappa) ? this.data.maps.via : this.data.manual.via)
      this.$emit('update:civico', (this.mappa) ? this.data.maps.civico : this.data.manual.civico)
      this.$emit('update:comune', (this.mappa) ? this.data.maps.comune : this.data.manual.comune)
      this.$emit('update:cap', (this.mappa) ? this.data.maps.cap : this.data.manual.cap)
      this.$emit('update:provincia', (this.mappa) ? this.data.maps.provincia : this.data.manual.provincia)
      this.$emit('update:nazione', (this.mappa) ? this.data.maps.nazione : this.data.manual.nazione)
    },
    clearDataMap(){
      this.data.maps = {
        via: '',
        civico: '',
        nazione: '',
        provincia: '',
        comune: '',
        cap: '',
      }

      this.updateValue()
    },
    clearMap(){
      this.clearDataMap()
      this.resetMarkers()
      map.setCenter(this.config.center)
      map.setZoom(this.config.zoom)
    },
    searchBoxKeyEnter(){
      if(this.searchbox === ''){ 
        this.clearMap()
      }
    }
  }
}
</script>

<style scoped>
/* Container componente */
#container_mappa{
  padding: 0;
}

/* Nascondi funzione componente */
.hide_class{
  visibility: hidden;
  height: 0;
}

/* Mappa */
.search_box{
  width: 60%;
  margin-top: 10px;
  margin-left: 20px;
}

.mappa_componente{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

/* Input */
#via{
  text-indent: 65px;
}

#civico{
  text-indent: 85px;
}

#comune{
  text-indent: 105px;
}

#cap{
  text-indent: 75px;
}

#provincia{
  text-indent: 110px;
}

#nazione{
  text-indent: 100px;
}
</style>